import axios from 'axios';

export const supervisionService = {
    getSupervisionSummaryService: (action) => axios.get('/supervision', { auth: true, params: { ...action.params } }),
    getStaffSupervisionSummaryService: (params) => axios.get('/supervision/staff-summary', { auth: true, params }),
};
